import { XmlSchemaIdentityConstraint } from './XmlSchemaIdentityConstraint';

export class XmlSchemaUnique extends XmlSchemaIdentityConstraint {}
